import Home from "./home";

const module = {
    Home
};

export default module;